import { PMCountCategoriesCard } from "@pimo/pimo-components/src/lib/pm-components";

import { getDropdownCount } from "../../../utils/dropdown-options";
import { isFieldEnabled } from "../../field-enabled";
import { DashboardCardContext } from "../context";

export function addCountCompletionOfItemsCard(ctx: DashboardCardContext) {
  const { view, language, getCardCopy } = ctx;

  const countCompletionOfItemsComponent = view.addComponent({
    component: PMCountCategoriesCard,
    layoutProps: {
      componentId: "countCompletionOfItemsComponent",
      labels: ["completion", "count"],
      description: getCardCopy(language, "itemCompletionCounts").description,
      title: getCardCopy(language, "itemCompletionCounts").title,
    },
  });

  countCompletionOfItemsComponent.mapState(
    ({ dashboard, settings, language }) => {
      const degreeOfCompletionCounts =
        dashboard?._calculated?.degreeOfCompletionCounts ?? {};

      const data = (
        settings?.configuration?.degreeOfCompletionDefinition ?? []
      ).map((entry) => {
        return {
          label: entry.name ?? "",
          count: getDropdownCount(degreeOfCompletionCounts, entry),
          color: entry.color ?? "",
        };
      });

      return {
        title: getCardCopy(language, "itemCompletionCounts").title,
        description: getCardCopy(language, "itemCompletionCounts").description,
        icon: "DonutLarge",
        data,
      };
    }
  );

  countCompletionOfItemsComponent.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "completion", "itemReporting")
  );
}
